/* eslint-disable import/order */
import "../../common/logging/EpTraceKitAdapter";
import "../../JQuery";
import "../../common/initCulture";
import { setupDatepicker } from "../../EasyProjectsCommon/General";
setupDatepicker();

import "../../EasyProjectsCommon/Ajax.js";
import "../../EasyProjectsCommon/customScrollbar.js";
import "../../EasyProjectsCommon/EpEnums.ts";
import "../../EasyProjectsCommon/JQueryValidationExtensions.js";
import "../../EasyProjectsCommon/mousewheelHelper.js";
import "../../EasyProjectsCommon/Select.js";

import "./EditRecord.js";
import "./EditRecordPopup.js";
